import React, { useState, useEffect } from 'react';
import { useContent } from '../../contexts/ContentContext';
import contentData from '../../data/content.json'; // Import default data for initialization
import './FeaturedProgramsAdmin.css'; // Reuse the same styles

const ContactSectionAdmin = ({ contentPath }) => {
  const { getContent, updateContent } = useContent();
  const [sectionData, setSectionData] = useState(null);

  // Get section configuration based on path
  const getSectionConfig = () => {
    if (contentPath.includes('pageHeader')) {
      return {
        title: 'En-tête de Page Contact',
        icon: 'fas fa-heading',
        description: 'Gérez le titre et sous-titre de votre page contact',
        type: 'simple',
        fields: [
          { key: 'title', label: 'Titre Principal', placeholder: 'Contactez-nous', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Nous sommes toujours disponibles...', type: 'textarea' }
        ]
      };
    }

    if (contentPath.includes('contactInfo')) {
      return {
        title: 'Informations de Contact',
        icon: 'fas fa-info-circle',
        description: 'Gérez les informations de contact affichées sur votre site',
        arrayKey: 'contactInfo',
        itemName: 'contact',
        itemFields: [
          { key: 'type', label: 'Type', placeholder: 'email' },
          { key: 'title', label: 'Titre', placeholder: 'Email Professionnel' },
          { key: 'description', label: 'Description', placeholder: 'Contactez-nous par email', type: 'textarea' },
          { key: 'value', label: 'Valeur', placeholder: 'contact@dentoxcellence.com' },
          { key: 'link', label: 'Lien', placeholder: 'mailto:contact@dentoxcellence.com' },
          { key: 'icon', label: 'Icône', placeholder: 'fas fa-envelope' },
          { key: 'availability', label: 'Disponibilité', placeholder: '24h/24 - 7j/7' }
        ]
      };
    }

    if (contentPath.includes('contactForm')) {
      return {
        title: 'Formulaire de Contact',
        icon: 'fas fa-file-alt',
        description: 'Gérez les champs et options du formulaire de contact',
        type: 'form',
        fields: [
          { key: 'title', label: 'Titre', placeholder: 'Demander des Informations', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Remplissez ce formulaire...', type: 'textarea' },
          { key: 'cities', label: 'Villes disponibles', placeholder: 'Alger', type: 'stringArray' },
          { key: 'subjects', label: 'Sujets de formations', placeholder: 'Implantologie', type: 'stringArray' },
          { key: 'experienceOptions', label: 'Options d\'expérience', placeholder: '0-2 ans', type: 'stringArray' },
          { key: 'messagePlaceholder', label: 'Placeholder du message', placeholder: 'Décrivez vos besoins...', type: 'text' },
          { key: 'newsletterText', label: 'Texte newsletter', placeholder: 'Je souhaite recevoir...', type: 'textarea' },
          { key: 'submitText', label: 'Texte du bouton', placeholder: 'Envoyer la Demande', type: 'text' }
        ]
      };
    }
    
    if (contentPath.includes('quickActions')) {
      return {
        title: 'Actions Rapides',
        icon: 'fas fa-bolt',
        description: 'Gérez les actions rapides pour faciliter le contact',
        type: 'mixed',
        headerFields: [
          { key: 'title', label: 'Titre', placeholder: 'Actions Rapides', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Choisissez la méthode...', type: 'textarea' }
        ],
        arrayKey: 'actions',
        itemName: 'action',
        itemFields: [
          { key: 'type', label: 'Type', placeholder: 'whatsapp' },
          { key: 'title', label: 'Titre', placeholder: 'WhatsApp Direct' },
          { key: 'description', label: 'Description', placeholder: 'Chattez avec nous instantanément', type: 'textarea' },
          { key: 'link', label: 'Lien', placeholder: 'https://wa.me/...' },
          { key: 'icon', label: 'Icône', placeholder: 'fab fa-whatsapp' },
          { key: 'buttonClass', label: 'Classe CSS', placeholder: 'btn btn-success' },
          { key: 'buttonIcon', label: 'Icône Bouton', placeholder: 'fab fa-whatsapp' },
          { key: 'buttonText', label: 'Texte Bouton', placeholder: 'Contacter' }
        ]
      };
    }
    
    if (contentPath.includes('trainingLocations')) {
      return {
        title: 'Lieux de Formation',
        icon: 'fas fa-map-marker-alt',
        description: 'Gérez les lieux où se déroulent vos formations',
        type: 'mixed',
        headerFields: [
          { key: 'title', label: 'Titre', placeholder: 'Lieux de Formation', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Nos formations se déroulent...', type: 'textarea' }
        ],
        arrayKey: 'locations',
        itemName: 'lieu',
        itemFields: [
          { key: 'type', label: 'Type', placeholder: 'primary' },
          { key: 'city', label: 'Ville', placeholder: 'Annaba' },
          { key: 'description', label: 'Description', placeholder: 'Centre Principal' },
          { key: 'address', label: 'Adresse', placeholder: 'Centre de Formation DentoXcellence, Annaba' },
          { key: 'features', label: 'Caractéristiques', type: 'array', placeholder: 'Équipements de pointe' }
        ]
      };
    }
    
    if (contentPath.includes('registrationLinks')) {
      return {
        title: 'Liens d\'Inscription Rapide',
        icon: 'fas fa-user-plus',
        description: 'Gérez les liens d\'inscription rapide pour vos formations',
        type: 'mixed',
        headerFields: [
          { key: 'title', label: 'Titre', placeholder: 'Liens d\'Inscription Rapide', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Choisissez votre formation...', type: 'textarea' }
        ],
        arrayKey: 'programs',
        itemName: 'programme',
        itemFields: [
          { key: 'name', label: 'Nom', placeholder: 'Formation Cone Beam CBCT' },
          { key: 'description', label: 'Description', placeholder: 'Formation de référence...', type: 'textarea' },
          { key: 'duration', label: 'Durée', placeholder: '3 jours' },
          { key: 'price', label: 'Prix', placeholder: '150,000 DA' },
          { key: 'popular', label: 'Populaire', type: 'checkbox' }
        ]
      };
    }
    
    if (contentPath.includes('faq')) {
      return {
        title: 'Questions Fréquentes',
        icon: 'fas fa-question-circle',
        description: 'Gérez les questions fréquemment posées par vos clients',
        type: 'mixed',
        headerFields: [
          { key: 'title', label: 'Titre', placeholder: 'Questions Fréquentes', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Trouvez rapidement les réponses...', type: 'textarea' }
        ],
        arrayKey: 'questions',
        itemName: 'question',
        itemFields: [
          { key: 'question', label: 'Question', placeholder: 'Quelle est la durée de la formation ?', type: 'textarea' },
          { key: 'answer', label: 'Réponse', placeholder: 'La formation dure en moyenne...', type: 'textarea' }
        ]
      };
    }
    
    if (contentPath.includes('socialNetworks')) {
      return {
        title: 'Réseaux Sociaux',
        icon: 'fas fa-share-alt',
        description: 'Gérez vos liens vers les réseaux sociaux',
        type: 'mixed',
        headerFields: [
          { key: 'title', label: 'Titre', placeholder: 'Suivez-nous sur les Réseaux Sociaux', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Restez informé de nos dernières actualités...', type: 'textarea' }
        ],
        arrayKey: 'networks',
        itemName: 'réseau',
        itemFields: [
          { key: 'name', label: 'Nom', placeholder: 'Facebook' },
          { key: 'description', label: 'Description', placeholder: 'Suivez nos actualités', type: 'textarea' },
          { key: 'url', label: 'URL', placeholder: 'https://facebook.com/dentoxcellence' },
          { key: 'icon', label: 'Icône', placeholder: 'fab fa-facebook' }
        ]
      };
    }

    if (contentPath.includes('cta')) {
      return {
        title: 'Appel à l\'Action (CTA)',
        icon: 'fas fa-bullhorn',
        description: 'Gérez l\'appel à l\'action en bas de page',
        type: 'mixed',
        headerFields: [
          { key: 'title', label: 'Titre', placeholder: 'Prêt à Transformer Votre Pratique ?', type: 'text' },
          { key: 'subtitle', label: 'Sous-titre', placeholder: 'Rejoignez plus de 500 dentistes...', type: 'textarea' }
        ],
        arrayKey: 'buttons',
        itemName: 'bouton',
        itemFields: [
          { key: 'text', label: 'Texte du bouton', placeholder: 'Contact Immédiat' },
          { key: 'icon', label: 'Icône', placeholder: 'fab fa-whatsapp' },
          { key: 'link', label: 'Lien', placeholder: 'https://wa.me/...' },
          { key: 'type', label: 'Type', placeholder: 'primary' },
          { key: 'target', label: 'Target', placeholder: '_blank' }
        ]
      };
    }
    
    return {
      title: 'Section Contact',
      icon: 'fas fa-cog',
      description: 'Gérez cette section de contact',
      arrayKey: 'items',
      itemName: 'élément',
      itemFields: []
    };
  };

  useEffect(() => {
    const initializeContactData = async () => {
      const data = getContent(contentPath);
      console.log(`📊 Contact data loaded for ${contentPath}:`, data);
      
      // Check if we need to initialize contact data from defaults
      const config = getSectionConfig();
      
      // For contact sections, getContent returns the array directly, not an object
      const arrayData = Array.isArray(data) ? data : data?.[config.arrayKey];
      
      console.log(`📋 Array data for ${config.arrayKey}:`, arrayData);
      
      // If backend has empty array but default content has data, initialize backend
      if (Array.isArray(arrayData) && arrayData.length === 0) {
        const defaultContactData = contentData.contact?.[config.arrayKey];
        console.log(`📄 Default data for ${config.arrayKey}:`, defaultContactData);
        
        if (defaultContactData && Array.isArray(defaultContactData) && defaultContactData.length > 0) {
          console.log(`🔄 Initializing ${config.arrayKey} with ${defaultContactData.length} default items...`);
          
          // Initialize backend with default data
          updateContent(contentPath, defaultContactData);
          
          // Reload data after initialization
          setTimeout(() => {
            const newData = getContent(contentPath);
            console.log(`✅ Data after initialization:`, newData);
            setSectionData(newData);
          }, 100);
          return;
        }
      }
      
      // For contact sections, keep the array structure since that's what we're working with
      setSectionData(data);
    };
    
    initializeContactData();
  }, [contentPath, getContent, updateContent]);

  const config = getSectionConfig();

  const handleSectionUpdate = (field, value) => {
    updateContent(`${contentPath}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleItemUpdate = (index, field, value) => {
    // For mixed type (like cta), update nested array items
    if (config.type === 'mixed') {
      updateContent(`${contentPath}.${config.arrayKey}.${index}.${field}`, value);
    } else {
      updateContent(`${contentPath}.${index}.${field}`, value);
    }
    setSectionData(getContent(contentPath));
  };

  const handleArrayFieldUpdate = (itemIndex, fieldKey, arrayIndex, value) => {
    updateContent(`${contentPath}.${itemIndex}.${fieldKey}.${arrayIndex}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleAddArrayField = (itemIndex, fieldKey) => {
    const item = sectionData[itemIndex];
    const array = item[fieldKey] || [];
    updateContent(`${contentPath}.${itemIndex}.${fieldKey}`, [...array, '']);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteArrayField = (itemIndex, fieldKey, arrayIndex) => {
    const item = sectionData[itemIndex];
    const array = item[fieldKey].filter((_, i) => i !== arrayIndex);
    updateContent(`${contentPath}.${itemIndex}.${fieldKey}`, array);
    setSectionData(getContent(contentPath));
  };

  // String array handlers (for cities, subjects, etc.)
  const handleStringArrayUpdate = (fieldKey, arrayIndex, value) => {
    const array = sectionData[fieldKey] || [];
    const newArray = [...array];
    newArray[arrayIndex] = value;
    updateContent(`${contentPath}.${fieldKey}`, newArray);
    setSectionData(getContent(contentPath));
  };

  const handleAddStringToArray = (fieldKey) => {
    const array = sectionData[fieldKey] || [];
    updateContent(`${contentPath}.${fieldKey}`, [...array, '']);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteStringFromArray = (fieldKey, arrayIndex) => {
    const array = sectionData[fieldKey] || [];
    const newArray = array.filter((_, i) => i !== arrayIndex);
    updateContent(`${contentPath}.${fieldKey}`, newArray);
    setSectionData(getContent(contentPath));
  };

  const handleAddItem = () => {
    // For mixed type (like cta), work with nested array
    if (config.type === 'mixed') {
      const arrayData = sectionData[config.arrayKey] || [];
      const newItem = {};
      
      // Initialize new item with empty values based on field configuration
      config.itemFields.forEach(field => {
        if (field.type === 'array') {
          newItem[field.key] = [];
        } else if (field.type === 'checkbox') {
          newItem[field.key] = false;
        } else {
          newItem[field.key] = '';
        }
      });

      updateContent(`${contentPath}.${config.arrayKey}`, [...arrayData, newItem]);
      setSectionData(getContent(contentPath));
      return;
    }

    // For regular array types
    const items = Array.isArray(sectionData) ? sectionData : [];
    const newItem = {};
    
    // Initialize new item with empty values based on field configuration
    config.itemFields.forEach(field => {
      if (field.type === 'array') {
        newItem[field.key] = [];
      } else if (field.type === 'checkbox') {
        newItem[field.key] = false;
      } else {
        newItem[field.key] = '';
      }
    });

    updateContent(contentPath, [...items, newItem]);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteItem = (index) => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer ce ${config.itemName} ?`)) {
      // For mixed type (like cta), work with nested array
      if (config.type === 'mixed') {
        const arrayData = sectionData[config.arrayKey] || [];
        const updatedItems = arrayData.filter((_, i) => i !== index);
        updateContent(`${contentPath}.${config.arrayKey}`, updatedItems);
        setSectionData(getContent(contentPath));
        return;
      }

      // For regular array types
      const items = Array.isArray(sectionData) ? sectionData : [];
      const updatedItems = items.filter((_, i) => i !== index);
      updateContent(contentPath, updatedItems);
      setSectionData(getContent(contentPath));
    }
  };

  if (!sectionData) {
    return (
      <div className="programs-admin-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Chargement...</p>
      </div>
    );
  }

  const renderStringArrayField = (field) => {
    const array = sectionData[field.key] || [];
    
    return (
      <div className="form-group full-width">
        <div className="features-section">
          <div className="features-header">
            <label>{field.label}</label>
            <button
              type="button"
              className="btn-add-feature"
              onClick={() => handleAddStringToArray(field.key)}
            >
              <i className="fas fa-plus"></i>
              Ajouter
            </button>
          </div>
          
          <div className="features-list">
            {array.map((item, arrayIndex) => (
              <div key={arrayIndex} className="feature-item">
                <input
                  type="text"
                  value={item}
                  onChange={(e) => handleStringArrayUpdate(field.key, arrayIndex, e.target.value)}
                  placeholder={field.placeholder}
                />
                <button
                  type="button"
                  className="btn-delete-feature"
                  onClick={() => handleDeleteStringFromArray(field.key, arrayIndex)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderField = (item, field, index) => {
    if (field.type === 'textarea') {
      return (
        <div className="form-group full-width">
          <label>{field.label}</label>
          <textarea
            value={item[field.key] || ''}
            onChange={(e) => handleItemUpdate(index, field.key, e.target.value)}
            placeholder={field.placeholder}
            rows={3}
          />
        </div>
      );
    }
    
    if (field.type === 'checkbox') {
      return (
        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={item[field.key] || false}
              onChange={(e) => handleItemUpdate(index, field.key, e.target.checked)}
            />
            {field.label}
          </label>
        </div>
      );
    }
    
    if (field.type === 'array') {
      return (
        <div className="form-group full-width">
          <div className="features-section">
            <div className="features-header">
              <label>{field.label}</label>
              <button
                type="button"
                className="btn-add-feature"
                onClick={() => handleAddArrayField(index, field.key)}
              >
                <i className="fas fa-plus"></i>
                Ajouter
              </button>
            </div>
            
            <div className="features-list">
              {(item[field.key] || []).map((arrayItem, arrayIndex) => (
                <div key={arrayIndex} className="feature-item">
                  <input
                    type="text"
                    value={arrayItem}
                    onChange={(e) => handleArrayFieldUpdate(index, field.key, arrayIndex, e.target.value)}
                    placeholder={field.placeholder}
                  />
                  <button
                    type="button"
                    className="btn-delete-feature"
                    onClick={() => handleDeleteArrayField(index, field.key, arrayIndex)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
    
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <input
          type="text"
          value={item[field.key] || ''}
          onChange={(e) => handleItemUpdate(index, field.key, e.target.value)}
          placeholder={field.placeholder}
        />
      </div>
    );
  };

  // Render for simple sections (like pageHeader)
  if (config.type === 'simple') {
    return (
      <div className="programs-admin">
        <div className="admin-section-header">
          <div className="section-info">
            <h2>
              <i className={config.icon}></i>
              {config.title}
            </h2>
            <p>{config.description}</p>
          </div>
        </div>

        <div className="section-settings">
          {config.fields.map((field) => (
            <div key={field.key} className="setting-group">
              <label>{field.label}</label>
              {field.type === 'textarea' ? (
                <textarea
                  value={sectionData[field.key] || ''}
                  onChange={(e) => handleSectionUpdate(field.key, e.target.value)}
                  placeholder={field.placeholder}
                  rows={3}
                />
              ) : (
                <input
                  type="text"
                  value={sectionData[field.key] || ''}
                  onChange={(e) => handleSectionUpdate(field.key, e.target.value)}
                  placeholder={field.placeholder}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Render for form sections (like contactForm with arrays)
  if (config.type === 'form') {
    return (
      <div className="programs-admin">
        <div className="admin-section-header">
          <div className="section-info">
            <h2>
              <i className={config.icon}></i>
              {config.title}
            </h2>
            <p>{config.description}</p>
          </div>
        </div>

        <div className="section-settings">
          {config.fields.map((field) => {
            if (field.type === 'stringArray') {
              return <div key={field.key}>{renderStringArrayField(field)}</div>;
            }
            
            return (
              <div key={field.key} className="setting-group">
                <label>{field.label}</label>
                {field.type === 'textarea' ? (
                  <textarea
                    value={sectionData[field.key] || ''}
                    onChange={(e) => handleSectionUpdate(field.key, e.target.value)}
                    placeholder={field.placeholder}
                    rows={3}
                  />
                ) : (
                  <input
                    type="text"
                    value={sectionData[field.key] || ''}
                    onChange={(e) => handleSectionUpdate(field.key, e.target.value)}
                    placeholder={field.placeholder}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // Render for mixed sections (like cta with header fields AND array)
  if (config.type === 'mixed') {
    const arrayData = sectionData[config.arrayKey] || [];
    
    return (
      <div className="programs-admin">
        <div className="admin-section-header">
          <div className="section-info">
            <h2>
              <i className={config.icon}></i>
              {config.title}
            </h2>
            <p>{config.description}</p>
          </div>
          <button 
            className="btn-add-program"
            onClick={handleAddItem}
          >
            <i className="fas fa-plus"></i>
            Ajouter un {config.itemName}
          </button>
        </div>

        {/* Header fields (title, subtitle) */}
        <div className="section-settings">
          {config.headerFields.map((field) => (
            <div key={field.key} className="setting-group">
              <label>{field.label}</label>
              {field.type === 'textarea' ? (
                <textarea
                  value={sectionData[field.key] || ''}
                  onChange={(e) => handleSectionUpdate(field.key, e.target.value)}
                  placeholder={field.placeholder}
                  rows={2}
                />
              ) : (
                <input
                  type="text"
                  value={sectionData[field.key] || ''}
                  onChange={(e) => handleSectionUpdate(field.key, e.target.value)}
                  placeholder={field.placeholder}
                />
              )}
            </div>
          ))}
        </div>

        {/* Array items */}
        <div className="programs-list-admin">
          {arrayData.map((item, index) => (
            <div key={index} className="program-item-admin">
              <div className="program-header">
                <div className="program-title-area">
                  <h3>
                    <i className={config.icon}></i>
                    {item.text || item.name || `${config.itemName} ${index + 1}`}
                  </h3>
                </div>
                <div className="program-actions">
                  <button
                    className="btn-delete"
                    onClick={() => handleDeleteItem(index)}
                    title={`Supprimer ce ${config.itemName}`}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>

              <div className="form-grid">
                {config.itemFields.map((field) => (
                  <div key={field.key} className="form-group">
                    <label>{field.label}</label>
                    <input
                      type="text"
                      value={item[field.key] || ''}
                      onChange={(e) => handleItemUpdate(index, field.key, e.target.value)}
                      placeholder={field.placeholder}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {arrayData.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">
              <i className={config.icon}></i>
            </div>
            <h3>Aucun {config.itemName}</h3>
            <p>Commencez par ajouter votre premier {config.itemName}.</p>
            <button className="btn-add-first" onClick={handleAddItem}>
              <i className="fas fa-plus"></i>
              Ajouter le premier {config.itemName}
            </button>
          </div>
        )}
      </div>
    );
  }

  // Default render for array-based sections
  return (
    <div className="programs-admin">
      {/* Section Header Settings */}
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className={config.icon}></i>
            {config.title}
          </h2>
          <p>{config.description}</p>
        </div>
        <button 
          className="btn-add-program"
          onClick={handleAddItem}
        >
          <i className="fas fa-plus"></i>
          Ajouter un {config.itemName}
        </button>
      </div>

      {/* Section Title & Subtitle */}
      <div className="section-settings">
        <div className="setting-group">
          <label>Titre de la section</label>
          <input
            type="text"
            value={sectionData.title || ''}
            onChange={(e) => handleSectionUpdate('title', e.target.value)}
            placeholder={config.title}
          />
        </div>
        <div className="setting-group">
          <label>Sous-titre</label>
          <textarea
            value={sectionData.subtitle || ''}
            onChange={(e) => handleSectionUpdate('subtitle', e.target.value)}
            placeholder={`Description de ${config.title.toLowerCase()}...`}
            rows={2}
          />
        </div>
      </div>

      {/* Items List */}
      <div className="programs-list-admin">
        {(Array.isArray(sectionData) ? sectionData : []).map((item, index) => (
          <div key={index} className="program-item-admin">
            <div className="program-header">
              <div className="program-title-area">
                <h3>
                  <i className={config.icon}></i>
                  {item.title || item.name || item.city || item.question || `${config.itemName} ${index + 1}`}
                </h3>
                {item.type && (
                  <span className="program-badge">
                    {item.type}
                  </span>
                )}
                {item.popular && (
                  <span className="program-badge">
                    Populaire
                  </span>
                )}
              </div>
              <div className="program-actions">
                <button
                  className="btn-delete"
                  onClick={() => handleDeleteItem(index)}
                  title={`Supprimer ce ${config.itemName}`}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>

            {/* Clean Horizontal Form Fields */}
            <div className="form-grid">
              {config.itemFields.map((field) => renderField(item, field, index))}
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {(!Array.isArray(sectionData) || sectionData.length === 0) && (
        <div className="empty-state">
          <div className="empty-icon">
            <i className={config.icon}></i>
          </div>
          <h3>Aucun {config.itemName}</h3>
          <p>Commencez par ajouter votre premier {config.itemName}.</p>
          <button className="btn-add-first" onClick={handleAddItem}>
            <i className="fas fa-plus"></i>
            Ajouter le premier {config.itemName}
          </button>
        </div>
      )}
    </div>
  );
};

export default ContactSectionAdmin;